/** "cargoDescription" → "Cargo description" */
const words = (key: string) => key.replace(/([A-Z])/g, ' $1').replace(/^./, (c) => c.toUpperCase());
const filled = (v: unknown) => v !== '' && v !== undefined && v !== null;

/** A filled-in form as plain lines of text ("Customer: ABC Trading"), skipping what was left empty. Used to hand a form to Claude as a task. */
export function describeForm(form: Record<string, unknown>): string {
  return Object.entries(form)
    .flatMap(([key, value]) => {
      if (Array.isArray(value))
        return value.flatMap((item, i) => {
          const text =
            item && typeof item === 'object'
              ? Object.entries(item)
                  .filter(([, v]) => filled(v))
                  .map(([k, v]) => `${words(k)} ${String(v)}`)
                  .join(', ')
              : String(item);
          return text ? [`${words(key)} ${i + 1}: ${text}`] : [];
        });
      return filled(value) ? [`${words(key)}: ${String(value)}`] : [];
    })
    .join('\n');
}
